import { Stack } from '@mui/material';
import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect, lazy } from 'react';
import Loadable from '@components/Loading/Loadable';
import ScrollTop from '@components/buttons/ScrollTop';

import './index.css';
import { Helmet } from 'react-helmet-async';
import Banner from './BannerNew';

const News = Loadable(lazy(() => import('./News')));

const MediaPage = () => {
  AOS.init();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, []);

  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.workershigh.com/company-introduction/media"
          data-rh="true"
        />
        <meta
          property="og:url"
          content="https://www.workershigh.com/company-introduction/media"
          data-rh="true"
        />
        <meta
          name="description"
          content="언론 속의 워커스하이                                                                                                                                                                                                                        "
        />
        <title>워커스하이 | 언론 </title>
      </Helmet>
      <Stack
        id="root-about"
        sx={{
          maxWidth: '100%',
          backgroundColor: '#FFFFFF',
          alignItems: 'center'
        }}
      >
        <Banner />
        <News />
        <ScrollTop />
      </Stack>
    </>
  );
};

export default MediaPage;
